import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Background-preloads lazy feature modules EXCEPT those that opt out with route
 * data `{ preload: false }`. A lighter alternative to PreloadAllModules: the common
 * tenant pages are warmed after the initial load, while the heavy / rarely-needed
 * clusters (device VNC/VPN, platform-admin) are only fetched on first navigation.
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] === false ? of(null) : load();
  }
}
